import { render, staticRenderFns } from "./kline.vue?vue&type=template&id=2ead703a&scoped=true&"
import script from "./kline.vue?vue&type=script&lang=js&"
export * from "./kline.vue?vue&type=script&lang=js&"
import style0 from "./kline.vue?vue&type=style&index=0&id=2ead703a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ead703a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ead703a')) {
      api.createRecord('2ead703a', component.options)
    } else {
      api.reload('2ead703a', component.options)
    }
    module.hot.accept("./kline.vue?vue&type=template&id=2ead703a&scoped=true&", function () {
      api.rerender('2ead703a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/trade/center/view/kline.vue"
export default component.exports